module.exports = __webpack_public_path__ + "static/media/pic2.71b68716.jpg";